import styled from 'styled-components';

import { getTheme } from '../../util/theme';

export const PrimarySearchFormStyles = styled.section`
  width: 100%;

  .search-form {
    display: flex;
    margin-bottom: ${getTheme('space')};
    margin-left: auto;
    margin-right: auto;
    max-width: 30rem;
    position: relative;
    width: 100%;

    &__label {
      background-color: ${getTheme('white')};
      font-size: 0.75rem;
      left: ${getTheme('halfSpace')};
      padding: ${getTheme('eighthSpace')};
      position: absolute;
      top: -0.75rem;

      &.active {
        color: ${getTheme('primaryBlue')};
      }
    }

    &__input {
      border: 1px solid ${getTheme('grey')};
      border-right: none;
      border-radius: ${getTheme('quarterSpace')} 0 0 ${getTheme('quarterSpace')};
      font-size: 0.875rem;
      outline: none;
      padding: ${getTheme('halfSpace')};
      width: 100%;

      &:focus {
        border: 2px solid ${getTheme('primaryBlue')};
        border-right: none;

        + .search-form__button {
          border: 2px solid ${getTheme('primaryBlue')};
          border-left: none;
        }
      }
    }

    &__button {
      background-color: transparent;
      border-color: ${getTheme('grey')};
      border-left: none;
      border-radius: 0 ${getTheme('quarterSpace')} ${getTheme('quarterSpace')} 0;
      outline: none;
      -webkit-appearance: none;

      &:focus {
        svg {
          fill: ${getTheme('primaryBlue')};
          transform: scale(1.2);
        }
      }

      svg {
        transition: fill 0.2s ease-out, transform 0.2s ease-out;

        &:hover {
          fill: ${getTheme('primaryBlue')};
          transform: scale(1.2);
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/PrimarySearchForm/styled-components.js